/* eslint-disable multiline-ternary */
import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import Header from 'src/components/header/Header';
import { Card, ConditionalComponent, ConfirmModal, Loader, Tabs, TTabItem } from 'src/components/common';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import '../ideaHub/ideaHub.scss';
import IdeaHubBanner from 'src/components/ideahub-simple/IdeabHubBanner/IdeahubBanner';
import MyIdeaListCard from 'src/components/ideahub-simple/my-ideas-list/MyIdeaListCard';
import { TGetIdeaRequest } from 'src/services/apiEndpoint.types.ts';
import { getIdea } from 'src/store/ideaHub/ideaHub.slice';
import { AxiosError } from 'axios';
import IdeaDetail from 'src/components/ideahub-simple/idea-detail/IdeaDetail';
import IdeaReport from 'src/components/ideahub-simple/idea-report/IdeaReport';

const IdeaDetailSimple = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { paramValue } = useUrlParamValue();
    const { getIdentities } = useGetIdentity();
    const { viewIdea, viewEvaluatorResponses, viewDocuments } = useAppSelector(
        (store) => store.ideaHub
    );
    const { loading } = useAppSelector(
        (store) => store.common
    );

    const ideaId: string = paramValue({ paramName: 'id' }) as unknown as string;
    // state
    const [show, setShow] = useState<boolean>(false);
    const [currentTab, setCurrentTab] = useState<string>('Report');

    // constant 
    const { loggedInCompanyId, loggedInUserType, authenticatedId } = getIdentities();
    const tabItems: TTabItem[] = useMemo(() => {
        const tabs = [
            {
                key: 'Idea Details',
                text: 'Idea Details',
                disabled: false,
                component: (
                    <IdeaDetail viewIdea={viewIdea} />
                )
            },
            {
                key: 'Report',
                text: 'Report',
                disabled: false,
                component: (
                    <IdeaReport idea={viewIdea} />
                )
            }
        ];
        return tabs;
    }, [JSON.stringify(viewIdea)]);

    function handleNavigate() {
        navigate('/login?prev=/discover')
    }
    const fetchIdea = () => {
        const payload: TGetIdeaRequest = {
            ideaId,
            userId: authenticatedId
        };
        if (ideaId) {
            dispatch(getIdea(payload)).then((data: unknown) => {
                const status: number = (data as AxiosError)?.response?.status as number;

                if (status === 404) {
                    navigate('/not-found');
                }
            });
        }
    };
    useEffect(() => {
        fetchIdea();
        window.scrollTo(0, 0)
    }, [ideaId]);
    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
            <div className="dashboard">
                <Header />
                <div className="dashboard__body dashboard__newBody">
                    <Card className="dashboard__body__feed">
                        {!loading && <>
                            <IdeaHubBanner isView={true} viewIdea={viewIdea} />
                            <div>
                                <div>
                                    <Tabs activeItem={currentTab} onTabChange={setCurrentTab} items={tabItems} />
                                </div>
                            </div>
                        </>}
                        {loading && <Loader />}

                    </Card>
                    <div className="dashboard__cards">
                        <MyIdeaListCard isView={true} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default IdeaDetailSimple;
